export class ObjectFieldsTree {
    Tenant: number;
    ObjectTableCode: string;
}